import { render, staticRenderFns } from "./chaobdh.vue?vue&type=template&id=62b5a211&scoped=true&"
import script from "./chaobdh.vue?vue&type=script&lang=js&"
export * from "./chaobdh.vue?vue&type=script&lang=js&"
import style0 from "./chaobdh.vue?vue&type=style&index=0&id=62b5a211&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5a211",
  null
  
)

export default component.exports